const quizStore = {
  namespaced: true,
  state() {
    return {
      pokemonsGuessed: []
    }
  },
  mutations: {
    getPokemons(state) {
      state.pokemonsGuessed = JSON.parse(localStorage.getItem('pokemons')) || []
    },
    addPokemon(state, pokemon) {
      state.pokemonsGuessed = [...state.pokemonsGuessed, pokemon]
      localStorage.setItem('pokemons', JSON.stringify(state.pokemonsGuessed))
    },
    restartPokedex(state) {
      state.pokemonsGuessed = []
      localStorage.removeItem('pokemons')
    }
  }
}

export default quizStore
